import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function HeavyRainIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-heavy-rain"
    >
      <path
        d="M55.0684 23C67.2823 23 77.1836 32.9013 77.1836 45.1152C77.1836 45.5608 77.1695 46.0033 77.1436 46.4424H84.3457C93.6283 46.4424 101.154 53.9674 101.154 63.25C101.154 72.5325 93.6282 80.0576 84.3457 80.0576H34.8076C25.5251 80.0576 18.0002 72.5325 18 63.25C18 54.5784 24.5669 47.4402 32.999 46.5381C32.9691 46.0676 32.9531 45.5932 32.9531 45.1152C32.9531 32.9012 42.8544 23 55.0684 23Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <path
        d="M37.1477 76.3516C37.5058 75.6046 38.4017 75.2894 39.1487 75.6475C39.8956 76.0056 40.2108 76.9014 39.8528 77.6484L36.3528 84.9512C35.9947 85.6981 35.0988 86.0133 34.3518 85.6553C33.6049 85.2972 33.2897 84.4013 33.6477 83.6543L37.1477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0} />
      </path>
      <path
        d="M52.6477 76.3516C53.0058 75.6046 53.9017 75.2894 54.6487 75.6475C55.3956 76.0056 55.7108 76.9014 55.3528 77.6484L51.8528 84.9512C51.4947 85.6981 50.5988 86.0133 49.8518 85.6553C49.1049 85.2972 48.7897 84.4013 49.1477 83.6543L52.6477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.2} />
      </path>
      <path
        d="M42.1477 87.3516C42.5058 86.6046 43.4017 86.2894 44.1487 86.6475C44.8956 87.0056 45.2108 87.9014 44.8528 88.6484L41.3528 95.9512C40.9947 96.6981 40.0988 97.0133 39.3518 96.6553C38.6049 96.2972 38.2897 95.4013 38.6477 94.6543L42.1477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.4} />
      </path>
      <path
        d="M68.1477 76.3516C68.5058 75.6046 69.4017 75.2894 70.1487 75.6475C70.8956 76.0056 71.2108 76.9014 70.8528 77.6484L67.3528 84.9512C66.9947 85.6981 66.0988 86.0133 65.3518 85.6553C64.6049 85.2972 64.2897 84.4013 64.6477 83.6543L68.1477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.6} />
      </path>
      <path
        d="M83.6477 76.3516C84.0058 75.6046 84.9017 75.2894 85.6487 75.6475C86.3956 76.0056 86.7108 76.9014 86.3528 77.6484L82.8528 84.9512C82.4947 85.6981 81.5988 86.0133 80.8518 85.6553C80.1049 85.2972 79.7897 84.4013 80.1477 83.6543L83.6477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.8} />
      </path>
      <path
        d="M57.6477 87.3516C58.0058 86.6046 58.9017 86.2894 59.6487 86.6475C60.3956 87.0056 60.7108 87.9014 60.3528 88.6484L56.8528 95.9512C56.4947 96.6981 55.5988 97.0133 54.8518 96.6553C54.1049 96.2972 53.7897 95.4013 54.1477 94.6543L57.6477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={1.0} />
      </path>
      <path
        d="M73.1477 87.3516C73.5058 86.6046 74.4017 86.2894 75.1487 86.6475C75.8956 87.0056 76.2108 87.9014 75.8528 88.6484L72.3528 95.9512C71.9947 96.6981 71.0988 97.0133 70.3518 96.6553C69.6049 96.2972 69.2897 95.4013 69.6477 94.6543L73.1477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={1.2} />
      </path>
    </svg>
  );
}

export default memo(HeavyRainIcon);
